import { render } from "./Female.vue?vue&type=template&id=61cc42b8&scoped=true"
import script from "./Female.vue?vue&type=script&lang=js"
export * from "./Female.vue?vue&type=script&lang=js"

import "./Female.vue?vue&type=style&index=0&id=61cc42b8&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61cc42b8"]])

export default __exports__